/**
 * Đăng ký service worker (vite-plugin-pwa, generateSW, registerType autoUpdate): precache toàn
 * bộ asset build để chơi offline; build mới → SW mới tự kích hoạt và trang tải lại.
 * `?nosw=1` bỏ đăng ký (debug).
 */
import { registerSW } from 'virtual:pwa-register';

export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;
  if (new URLSearchParams(location.search).has('nosw')) return;
  registerSW({
    immediate: true,
    onRegisterError(e: unknown) {
      console.warn('[pwa] đăng ký service worker lỗi:', e);
    },
  });
}
